export function getIsFeatureEnabled(featureFlag: boolean | undefined): boolean {
  return typeof featureFlag === "boolean" && featureFlag;
}
